/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_ReconnectInputs */



/**
* | output |
* | --- |
* | "Reconnect" |
*
* @param {Sync_ReconnectInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sync_reconnect = /** @type {((inputs?: Sync_ReconnectInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_ReconnectInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se reconnecter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reconectar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reconectar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riconnetti")
	return /** @type {LocalizedString} */ ("Reconnect")
});